export const links = [
  {
    to: 'home',
    name: 'Home',
  },
  {
    to: 'aboutMe',
    name: 'About Me',
  },
  {
    to: 'services',
    name: 'Services',
  },
  {
    to: 'contactMe',
    name: 'Contact Me',
  }
];
